import { DashboardWrapper, NavigationAssistant } from "./Atom"
import { setSelectedDashboardTab } from "../../redux/slices/dashboardSlice"
import DashboardTabs from "../../components/Tabs/DashboardTabs"
import { useSelector } from "react-redux"
import DashboardTables from "../../components/Table/DashboardTable/DashboardTables"
import {
  fetchGroupsHandler,
  fetchOfficesHandler,
  fetchRegionsHandler,
} from "./apiUtils"
import { useCallback, useEffect, useMemo } from "react"
import {
  setMaevaGroups,
  setMaevaRegions,
  setMaevaPractices,
} from "../../redux/slices/metricSlice"
import { useAppDispatch } from "../../redux/hooks"
import { getTokenLocal } from "../../../helper/utils"
import { useNavigate } from "react-router-dom"
import { setLoading } from "../../redux/slices/appSlice"
import { DashboardHeader } from "../../components/Headers"

const Dashboard = () => {
  const token = getTokenLocal()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const maevaSelectedGroup = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll?.[0]
  })

  const maevaSelectedRegion = useSelector((state: any) => {
    return state.metric.maevaSelectedRegions?.[0]
  })

  const maevaSelectedPractice = useSelector((state: any) => {
    return state.metric.maevaSelectedPractices?.[0]
  })

  const selectedDashboardTab = useSelector(
    (state: any) => state.dashboard.selectedDashboardTab,
  )

  const loading = useCallback(
    (loadVal: boolean) => {
      dispatch(setLoading(loadVal))
    },
    [dispatch],
  )

  useEffect(() => {
    fetchGroupsHandler({
      token,
      dispatch: (payload: any) => {
        dispatch(setMaevaGroups(payload))
      },
      navigate,
      loading,
    })
  }, [])

  useEffect(() => {
    if (maevaSelectedGroup) {
      fetchRegionsHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaRegions(payload))
        },
        navigate,
        group: maevaSelectedGroup,
        loading,
      })
    }
  }, [maevaSelectedGroup])

  useEffect(() => {
    if (maevaSelectedRegion) {
      fetchOfficesHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaPractices(payload))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
      })
    }
  }, [maevaSelectedRegion])

  const fetchByDashboardTabId = useCallback(
    (tab: any) => {
      if (!tab || typeof tab !== "object" || !("id" in tab)) {
        return
      }

      if (tab?.id === selectedDashboardTab?.id) {
        return
      }
      dispatch(setSelectedDashboardTab(tab))
    },
    [dispatch, selectedDashboardTab?.id],
  )

  const navigationData = useMemo(
    () => [
      {
        label: "Select a group to proceed",
        value: maevaSelectedGroup ? true : false,
      },
      {
        label: "Select a region to proceed",
        value: maevaSelectedRegion ? true : false,
      },
      {
        label: "Select a office to proceed",
        value: maevaSelectedPractice ? true : false,
      },
    ],
    [maevaSelectedGroup, maevaSelectedRegion, maevaSelectedPractice],
  )

  return (
    <>
      <DashboardWrapper>
        <DashboardHeader name="Dashboard" />

        {maevaSelectedPractice ? (
          <>
            <DashboardTabs fetchByDashboardTabId={fetchByDashboardTabId} />
            <DashboardTables />
          </>
        ) : (
          <NavigationAssistant data={navigationData} />
        )}
      </DashboardWrapper>
    </>
  )
}

export default Dashboard
